import { AccountManager } from '../../pages/Settings';
import React from 'react';
import { businessStore } from '../../stores';

const AccountManagerContainer = ({ closeModal }) => {
	const accountManager = businessStore.business.accountManager;
	return <AccountManager closeModal={closeModal} accountManager={accountManager}/>;
};

export default AccountManagerContainer;
